export const DaysList: any[] =
    [
        { "Name": "Last 7 days", "NameAr": "آخر 7 أيام", "Value": "7" },
        { "Name": "Last 15 days", "NameAr": "آخر 15 يومًا", "Value": "15" },
        { "Name": "Last 30 days", "NameAr": "آخر 30 يومًا", "Value": "30" },
        { "Name": "Last 50 days", "NameAr": "آخر 50 يومًا", "Value": "50" },
        { "Name": "Last 100 days", "NameAr": "آخر 100 يوم", "Value": "100" },
        { "Name": "Last 150 days", "NameAr": "آخر 150 يومًا", "Value": "150" },
        { "Name": "Last 180 days", "NameAr": "آخر 180 يومًا", "Value": "180" }
    ];

export const StatementDaysList: any[] =
    [
        { "Name": "Last 30 days", "NameAr": "آخر 30 يومًا", "Value": "30" },
        { "Name": "Last 60 days", "NameAr": "آخر 60 يومًا", "Value": "60" },
        { "Name": "Last 90 days", "NameAr": "آخر 90 يوم", "Value": "90" },
        { "Name": "Last 120 days", "NameAr": "آخر 120 يومًا", "Value": "120" },
        { "Name": "Last 150 days", "NameAr": "آخر 150 يومًا", "Value": "150" },
        { "Name": "Last 180 days", "NameAr": "آخر 180 يومًا", "Value": "180" },
        { "Name": "Custom", "NameAr": "مخصص", "Value": "custom" }
    ]

